var dsbridge = require('dsbridge')
import API from '@/request/api'
import store from '@/store'
import i18n from '@/i18n'
import Vue from 'vue'

const debugParams = {
  shopId: store.state.shop_x.id,
  type: 1,
  autoOnlyBendRead: true,
}

export default {
  dsbridge_map: {
    openCashDrawer: 'utils.openCashDrawer', // 打开钱箱
    loadCredentials: 'login.loadCredentials', // 加载凭据
    persistCredentials: 'login.persistCredentials', // 持久化凭据
    eftQuery: 'eft.query', // EFT支付-query
    eftPay: 'eft.pay', // EFT支付-pay
    eftRefund: 'eft.refund', // EFT支付-refund
    initMediaDevices: 'camera.takePic', // 初始化媒体设备
    getMediaDevicesId: 'camera.deviceId', // 获取媒体设备ID
    cameraWatch: 'cameraToH5', // 获取媒体设备ID
  },

  dsbridge_call(key, data) {
    if (dsbridge && dsbridge.hasNativeMethod(key)) {
      try {
        const RESULT = dsbridge.call(key, data)
        console.log(`执行${key}方法成功，结果为${RESULT}`)
        API.debug({ ...debugParams, desc: `执行${key}方法成功，结果为${RESULT}` })
        return RESULT
      } catch (error) {
        console.log(`执行${key}方法失败，错误为${error}`)
        API.debug({ ...debugParams, desc: `执行${key}方法失败，错误为${error}` })
        return null
      }
    } else {
      if (['eft.pay', 'eft.refund'].includes(key)) {
        Vue.prototype.$confirm(i18n.t('pay.eftPayIsNotSupport'), i18n.t('common.warning2'), {
          confirmButtonText: i18n.t('common.yes'),
          // cancelButtonText: i18n.t('common.no'),
          showCancelButton: false,
          type: 'warning'
        // }).then(() => {
        // }).catch(() => {
        })
      }
      console.log(`未找到${key}方法`)
      API.debug({ ...debugParams, desc: `未找到${key}方法` })
      return null
    }
  },

  dsbridge_watch(key, callBack) {
    if (dsbridge) {
      try {
        dsbridge.register(key, callBack);
      } catch (error) {
        return null
      }
    } else {
      return null
    }


    // window.WebViewJavascriptBridge.registerHandler('cameraToH5', function(data, responseCallback) {
    //   responseCallback('通知Java结果' + data);
    //   API.debug({ ...debugParams, desc: `通知Java结果为${error}` })
    // });

  },
}